import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2bc2bf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left-parenthesis" }, null, -1))
const _hoisted_2 = ["src"]
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "right-parenthesis" }, null, -1))

import ActuatorInput from '../Inputs/ActuatorInput'
import PhalanxInput from '../Inputs/PhalanxInput'
import { ref, onMounted, inject, reactive, computed } from 'vue'
import { v4 as uuidv4 } from 'uuid'
import { getFancyActuator, getFancyPhalanx } from '../utils'
import ContactPicker from '../Inputs/ContactPicker'
import { Contact } from '../struct'


export default {
  __name: 'ContactComponent',
  props: {
  modelValue: {
    required: true
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props;




const hoveredInputButton = inject('hoveredInputButton', null)

const id = uuidv4()
const contact = reactive(props.modelValue ?? { actuator: [], phalanx: [] })
const reload = ref(0)
const displayedPicker = ref(null)
const widths = ref({
  actuator: 0,
  phalanx: 0,
  parameters: 0
})

const inConstruction = inject('inConstruction', false)

const actionImg = computed(() => {
  switch (contact.action) {
    case Contact.Object:
      return require('../assets/glyphs/Object.svg')
    case Contact.Air:
      return require('../assets/glyphs/Air.svg')
    case Contact.Contact:
      return require('../assets/glyphs/Contact.svg')
    default:
      return require('../assets/glyphs/Plus.svg')
  }
})

function displayPicker (type) {
  if (!inConstruction) return
  displayedPicker.value = displayedPicker.value === type ? null : type
}

function closePicker () {
  displayedPicker.value = null
  emits('update:modelValue', contact)
}

function destroy () {
  emits('update:modelValue', null)
}

function onDrop (evt) {
  const microgeste = JSON.parse(evt.dataTransfer.getData('microgeste'))
  if (Object.values(Contact).includes(microgeste.type)) {
    contact.contact = { type: microgeste.type, action: microgeste.type }
    reload.value++
  }
  emits('update:modelValue', contact)
}

const resizeObserver = new ResizeObserver((entries) => {
  for (const entry of entries) {
    const { width } = entry.contentRect
    if (entry.target.id === `${id}-actuator`) {
      widths.value.actuator = width
    } else if (entry.target.id === `${id}-phalanx`) {
      widths.value.phalanx = width
    } else if (entry.target.id === `${id}-parameters`) {
      widths.value.parameters = width
    }
  }
})

onMounted(() => {
  resizeObserver.observe(document.getElementById(`${id}-actuator`))
  resizeObserver.observe(document.getElementById(`${id}-phalanx`))
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "contact-container",
    onDragover: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
    onDragenter: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[8] || (_cache[8] = $event => (onDrop($event)))
  }, [
    _hoisted_1,
    _createElementVNode("div", {
      class: _normalizeClass(["contact", (_unref(inConstruction)) ? 'in-construction' : '']),
      style: _normalizeStyle(`
            padding-left:${widths.value.actuator}px;
            padding-right:${widths.value.phalanx}px;
           `)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([(_unref(hoveredInputButton) === 'contact') ? 'red' : '', "action"]),
        onClick: _cache[0] || (_cache[0] = $event => (displayPicker('contact')))
      }, [
        (_openBlock(), _createElementBlock("img", {
          src: _unref(actionImg),
          key: reload.value,
          alt: "+"
        }, null, 8, _hoisted_2))
      ], 2),
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => (displayPicker('actuator'))),
        id: `${_unref(id)}-actuator`,
        class: "actuator"
      }, _toDisplayString(_unref(getFancyActuator)(contact.actuator, _unref(inConstruction))), 9, _hoisted_3),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = $event => (displayPicker('phalanx'))),
        id: `${_unref(id)}-phalanx`,
        class: "phalanx"
      }, _toDisplayString(_unref(getFancyPhalanx)(contact.phalanx, _unref(inConstruction))), 9, _hoisted_4),
      (displayedPicker.value === 'contact')
        ? (_openBlock(), _createBlock(_unref(ContactPicker), {
            key: 0,
            modelValue: contact.action,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((contact.action) = $event)),
            onDestroy: destroy,
            onClose: closePicker
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (displayedPicker.value === 'actuator')
        ? (_openBlock(), _createBlock(_unref(ActuatorInput), {
            key: 1,
            modelValue: contact.actuator,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((contact.actuator) = $event)),
            onClose: closePicker
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (displayedPicker.value === 'phalanx')
        ? (_openBlock(), _createBlock(_unref(PhalanxInput), {
            key: 2,
            modelValue: contact.phalanx,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((contact.phalanx) = $event)),
            onClose: closePicker
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ], 6),
    _hoisted_5
  ], 32))
}
}

}